export interface LanguageConfig {
  code: string;
  name: string;
  nativeName: string;
  countryCode: string;
  isActive: boolean;
}

// Desteklenen dillerin konfigürasyonu
export const SUPPORTED_LANGUAGES: LanguageConfig[] = [
  {
    code: 'tr',
    name: 'Turkish',
    nativeName: 'Türkçe',
    countryCode: 'TR',
    isActive: true,
  },
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    countryCode: 'GB',
    isActive: true,
  },
  // Gelecekte eklenecek diller için örnekler (şu an aktif değil)
  // {
  //   code: 'de',
  //   name: 'German',
  //   nativeName: 'Deutsch',
  //   countryCode: 'DE',
  //   isActive: false,
  // },
  // {
  //   code: 'es',
  //   name: 'Spanish',
  //   nativeName: 'Español',
  //   countryCode: 'ES',
  //   isActive: false,
  // },
  // {
  //   code: 'fr',
  //   name: 'French',
  //   nativeName: 'Français',
  //   countryCode: 'FR',
  //   isActive: false,
  // },
  // {
  //   code: 'it',
  //   name: 'Italian',
  //   nativeName: 'Italiano',
  //   countryCode: 'IT',
  //   isActive: false,
  // },
];

// Aktif dilleri filtrele
export const ACTIVE_LANGUAGES = SUPPORTED_LANGUAGES.filter(
  (lang) => lang.isActive
);

// Varsayılan dil
export const DEFAULT_LANGUAGE = 'en';

// Dil kodlarının tip tanımı
export type SupportedLanguageCode =
  (typeof SUPPORTED_LANGUAGES)[number]['code'];

// Dil konfigürasyonunu kod ile bul
export const getLanguageConfig = (code: string): LanguageConfig | undefined => {
  return SUPPORTED_LANGUAGES.find((lang) => lang.code === code);
};

// Aktif dil konfigürasyonunu kod ile bul
export const getActiveLanguageConfig = (
  code: string
): LanguageConfig | undefined => {
  return ACTIVE_LANGUAGES.find((lang) => lang.code === code);
};
